import React from "react";
import { Resource } from "react-admin";
import ConfigsIcon from "@material-ui/icons/Settings";
import PermissionDenied from "../../components/PermissionDenied";
import { POLICY_CONSOLE } from "../../common/rolesManagement";

import List from "./List";
export default permissions => (
    <Resource
        name="configs"
        icon={ConfigsIcon}
        list={
            permissions &&
            permissions.includes(POLICY_CONSOLE.CAN_LOGIN_ON_MAINTENANCE)
                ? List
                : PermissionDenied
        }
    />
);



// WEBPACK FOOTER //
// ./src/resources/Configs/index.js